import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { MDBBtn, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import axios from "axios";
// components
import Google from "./Google";
import MetaTagsBusinessOwners from "../meta-tags-seo/MetaTagsBusinessOwners";
// import Facebook from "./Facebook";
//
import "./login-index.css";
import { validate } from "./validate";
// img
import closeIcon from "../../images/header/close.png";
import logo from "../../images/home-body/logo gishniz.png";
import facebook_login from "../../images/facebook-login.png";
import google_login from "../../images/google-login.png";
// config
import configData from "../../config/config.json";
//icons
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const Login = (props) => {
  const [render, setRender] = useState(false);

  // this 2 satae for Meta Tags
  const [MTagsCome, setMTagsCome] = useState(false);
  const [MetaData, setMetaData] = useState({});

  const { state } = props.location;

  const [inputData, setInputData] = useState({
    username: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const [existErr, setExistErr] = useState();
  const [fillErr, setFillErr] = useState();
  const [disable, setDisable] = useState(false);
  const [apiError, setApiError] = useState([]);

  const history = useHistory();

  useEffect(() => {
    setErrors(validate(inputData, "login"));
  }, [inputData, touched]);

  useEffect(() => {
    // remove choose-owner for now
    // if (!JSON.parse(localStorage.getItem("SelectedOwner"))) {
    //   props.history.push({
    //     pathname: "/choose-owner",
    //   });
    // } else {
    // remove cookies comment for now-----
    // var cookies = document.cookie.split(";");
    // for (var i = 0; i < cookies.length; i++) {
    //   var cookie = cookies[i];
    //   var eqPos = cookie.indexOf("=");
    //   var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    //   document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    // }
    // remove cookies comment for now-----
    // }
  }, []);

  const inputChangeHandler = (event) => {
    if (event.target.name === "isAccepted") {
      if (inputData.isAccepted) {
        setInputData({
          ...inputData,
          [event.target.name]: false,
        });
      } else {
        setInputData({
          ...inputData,
          [event.target.name]: true,
        });
      }
    } else {
      setInputData({ ...inputData, [event.target.name]: [event.target.value] });
      setExistErr(false);
      setFillErr(false);
    }
  };

  //api header
  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    // Email: inputData.username,
    // Password: inputData.password,
  };

  const submitHandler = (event) => {
    event.preventDefault();

    var cookieDay = 1;
    if (inputData.isAccepted) {
      cookieDay = 365;
    }

    if (!Object.keys(errors).length) {
      // success
      setApiError([]);
      setExistErr(false);
      setFillErr(false);
      setDisable(true);

      axios
        .post(
          configData.API_DOMAIN + "/api/v1/BusinessOwners/login",
          {
            email: inputData.username[0],
            password: inputData.password[0],
          },
          {
            headers: header,
          }
        )
        .then((response) => {
          setDisable(false);

          if (response.data.isSuccess) {
            if (response.data.data.ownerDetail.emailApproved) {
              setCookie(
                "OwnerId",
                response.data.data.ownerDetail.boId,
                cookieDay
              );
              setCookie("BizId", response.data.data.ownerDetail.bId, cookieDay);
              setCookie("token", response.data.data.token.token, cookieDay);

              // setcookie to use in dashboard
              setCookie(
                "CatIds",
                response.data.data.ownerDetail.CatIds,
                cookieDay
              );
              localStorage.setItem(
                "OwnerDetail",
                JSON.stringify(response.data.data.ownerDetail)
              ); //set local

              // props.history.push({
              //   pathname: "/register-business-step1",
              //   state: response.data.data.ownerDetail.boId, // your data array of objects
              // });

              history.push({
                pathname: "/check-complete",
              });
            } else {
              setCookie(
                "OwnerIdConfirm",
                response.data.data.ownerDetail.boId,
                1
              );
              props.history.push({
                pathname: "/register-email",
                state: response.data.data.ownerDetail.email, // your data array of objects
              });
            }
          } else {
            // isSuccess = false
            setApiError(response.data.message);
          }

          // if (response.data.msg == "done") {
          //   setCookie("OwnerId", response.data.OwnerDetail.OwnerId, 1);
          //   setCookie("BizId", response.data.OwnerDetail.BizId, 1);
          //   localStorage.setItem(
          //     "OwnerDetail",
          //     JSON.stringify(response.data.OwnerDetail)
          //   ); //set local
          //   // setcookie to use in dashboard
          //   setCookie("CatIds", response.data.OwnerDetail.CatIds, 1);

          //   props.history.push({
          //     pathname: "/register-business-step1",
          //     state: response.data.OwnerDetail.OwnerId, // your data array of objects
          //   });
          // } else if (response.data.msg == "login-failed") {
          //   console.log("login-failed");
          //   setExistErr(true);
          // } else if (response.data.msg == "fill-all") {
          //   console.log("fill-all");
          //   setFillErr(true);
          // }
        });
    } else {
      setTouched({
        username: true,
        password: true,
      });
    }
    // Cookies
    // let OwnerIdCookie = getCookie("OwnerId");

    // if (OwnerIdCookie != "") {
    //   if (
    //     userNameCookie == inputData.username[0] &&
    //     passWordCookie == inputData.password[0]
    //   ) {
    //     alert("Welcome " + OwnerIdCookie);
    //     history.push("/register-business-step1");
    //   } else {
    //     alert("userName or passWord incorrect.");
    //     setInputData({
    //       username: "",
    //       password: "",
    //     });
    //   }
    // }
    // } else {
    //   setCookie("userName", inputData.username[0], 10);
    //   setCookie("passWord", inputData.password[0], 10);
    //   let userNameCookieonline = getCookie("userName");
    //   alert("Welcome " + userNameCookieonline);
    //   history.push("/register-business-step1");
    // }
  };

  //   setCookie
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    document.cookie =
      cname +
      "=" +
      cvalue +
      ";" +
      expires +
      " domain=en-biz.gishniz.com; path=/";
  }
  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  //api header
  const headerMeta = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Page: "login",
  };

  useEffect(() => {
    setRender(false);
    let OwnerIdCookie = getCookie("OwnerId");
    if (OwnerIdCookie) {
      props.history.push({
        pathname: "/business-dashboard",
      });
    } else {
      setRender(true);
      axios
        .get(configData.API_DOMAIN + "/api/v1/MetaTags/businessOwner", {
          headers: headerMeta,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setMTagsCome(true);
            setMetaData(response.data.data);
          }
        })
        .catch((error) => {
          // alert(error);
        });
    }
  }, []);

  // for password btn icon
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <>
      {render ? (
        <>
          {MTagsCome ? <MetaTagsBusinessOwners data={MetaData} /> : ""}

          <div className="centerr">
            <div className="centerr d-none d-md-block">
              <Link to="/" className=" logo-login-a ">
                <img src={logo} alt="logo gishniz" className="logo-login-lap" />
              </Link>
            </div>

            <div className="login-container centerr">
              <MDBContainer className="">
                <MDBRow className="text-end">
                  <Link to="/" className="a-close-img">
                    <img
                      className="login-close-img me-0"
                      src={closeIcon}
                      alt="close icon"
                    />
                  </Link>
                </MDBRow>
                <MDBRow className="">
                  <div className="col-12 text-center">
                    <div className="centerr">
                      <Link to="/" className=" logo-login-a d-block d-md-none">
                        <img
                          src={logo}
                          alt="logo gishniz"
                          className="logo-login "
                        />
                      </Link>
                    </div>

                    <p className=" login-matn1 fs-xss-21 color-515151 fw-bold mt-3 mt-md-0 mb-2">
                      ورود به حساب کسب‌وکار
                    </p>
                    <p className="fs-xss-12 color-8d8c8c mb-4 pb-2 pb-md-0 login-matn2">
                      برای استفاده از امکانات وبسایت لطفا وارد حساب کاربری شوید.
                    </p>
                  </div>
                  <div className="col-12 mt-1 padding-xss-32">
                    {/* <MDBBtn className="shadow-off account-login-btn text-start">
                  ورود با فیسبوک
                  <img
                    className="account-login-img"
                    src={facebook_login}
                    alt=""
                  />
                </MDBBtn> */}
                    {/* <Facebook /> */}
                    {/* <MDBBtn className="shadow-off account-login-btn text-start">
                  ورود با گوگل
                  <img
                    className="account-login-img"
                    src={google_login}
                    alt=""
                  />
                </MDBBtn> */}
                    {/* <Google /> */}
                    <Google login={true} />

                    <div className="centerr">
                      <div className="divider-login d-flex align-items-center">
                        <p className="text-center mb-0 divider-login-text fs-xss-12">
                          ورود با ایمیل یا نام کاربری
                        </p>
                      </div>
                    </div>
                    <div className="">
                      <form>
                        <input
                          dir="ltr"
                          name="username"
                          value={inputData.username}
                          onChange={inputChangeHandler}
                          className={
                            errors.username && touched.username
                              ? "input-login mb-md-1 border-error font-family-en"
                              : "input-login mb-md-1 font-family-en"
                          }
                          type="text"
                          placeholder="ایمیل یا نام کاربری"
                        />
                        {errors.username && touched.username && (
                          <span className="input-error">{errors.username}</span>
                        )}
                        <div className="position-relative">
                          <input
                            dir="ltr"
                            name="password"
                            value={inputData.password}
                            onChange={inputChangeHandler}
                            className={
                              errors.password && touched.password
                                ? "input-login font-family-en input-login-pass border-error mt-2 "
                                : "input-login font-family-en input-login-pass mt-2"
                            }
                            type={showPassword ? "text" : "password"}
                            maxLength="25"
                            placeholder="رمز عبور"
                          />
                          <IconButton
                            className="show-pass-btn"
                            size="small"
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="start"
                          >
                            {showPassword ? (
                              <VisibilityOff fontSize="small" />
                            ) : (
                              <Visibility fontSize="small" />
                            )}
                          </IconButton>
                        </div>
                        {errors.password && touched.password && (
                          <span className="input-error">{errors.password}</span>
                        )}
                        {existErr && (
                          <span className="input-error">
                            آدرس ایمیل یا رمز عبور اشتباه است.
                          </span>
                        )}
                        {fillErr && (
                          <span className="input-error">
                            لطفا همه موارد را پر کنید.
                          </span>
                        )}
                        {apiError.map((item) => (
                          <span className="input-error">{item}</span>
                        ))}

                        <div className="rightt login-matn3-div d-flex justify-content-between align-items-end ">
                          <Link
                            className="color-5ae6a2 text-end login-matn3 mb-0"
                            to="/forget-password"
                          >
                            {/* <p className="text-end login-matn3 mb-0 "> */}
                            رمز عبور رو فراموش کردی؟
                            {/* </p> */}
                          </Link>
                          <label className="container-s5 m-0">
                            <span className="color-242B2E">
                              مرا بخاطر بسپار
                            </span>
                            <input
                              type="checkbox"
                              name="isAccepted"
                              value={inputData.isAccepted}
                              onChange={inputChangeHandler}
                            />
                            <span className="s5-24h me-0 me-2"></span>
                          </label>
                        </div>
                        <MDBBtn
                          disabled={disable}
                          onClick={submitHandler}
                          type="submit"
                          className="shadow-off hov-shadow-btn submit-login-btn text-center"
                        >
                          ورود به حساب
                        </MDBBtn>
                        <div className="d-flex justify-content-center mb-4 fs-14 fs-xss-14">
                          <p className="color-242b2e">حساب کاربری ندارید؟ </p>
                          <Link className="color-5ae6a2" to="/signup">
                            <p className="text-end me-2">ثبت نام </p>
                          </Link>
                        </div>
                      </form>
                    </div>
                  </div>
                </MDBRow>
              </MDBContainer>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default Login;
